import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LastMile } from './assets';
import { map } from 'lodash';
import SolutionCard from './SolutionCard';

const SolutionsMenu = ({ solutions }) => {

    const { t } = useTranslation('public');

    return (
        <Box sx={{ paddingInline: { xs: 0, md: 4 }, paddingBlockStart: 2 }}>
            <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '130%' }}>
                {t(solutions.title)}
            </Typography>
            <Typography sx={{ color: "#1E1E1E", fontSize: '14px', fontStyle: 'normal', fontWeight: 300, lineHeight: '130%', mb: 3, mt: 0.5 }}>
                {t(solutions.subtitle)}
            </Typography>
            {
                map(
                    solutions.list,
                    solution => <SolutionCard solution={solution} sx={{ marginBlock: 3 }} learnMore={t(solutions.learnMore)} />
                )
            }
        </Box>
    );
}

export default SolutionsMenu;
